// You can write your custom Javascript here
var $ = jQuery;

$(document).ready(function () {
  $(".pz--save").one("click",function(){ 
    $('.personalize-vue').after('<script>$("a.btn-close").click(function(){var o=0==$(".personalize__form--body input[type=text]").filter(function(){return 0==$.trim($(this).val()).length}).length;console.log(o),!0===o&&(console.log("true"),$("#addtocart").prop("disabled",!0),$("#pz-confirmed").prop("disabled",!1)),!1===o&&(console.log("false"),$("#addtocart").prop("disabled",!0),$("#pz-confirmed").prop("disabled",!0)),$("#addtocart").prop("disabled",!0)});</script>');   
  });
      setTimeout(function(){
$("body input#CLEAR-BIRTHSTONE").on("click",function(){
  console.log($(this));
  $("div.personalize__form").find("button[type='button']").attr("disabled", false);
});
    console.log("seption2");
  }, 3000);
  $(".pz--save").click(function(){
    var checkInput = $(".personalize__form--body input[type=text]").filter(function () {
      return $.trim($(this).val()).length == 0
    }).length == 0;
    console.log(checkInput);
    if(checkInput === true){
      console.log("true");
      $("#addtocart").prop("disabled", true);	
      $("#pz-confirmed").prop("disabled", false);
    }
    if(checkInput === false){
      console.log("false");
      $("#addtocart").prop("disabled", true);
      $("#pz-confirmed").prop("disabled", true);
    }
    $("#addtocart").prop("disabled", true);
  });
  var checkInput1 = $(".personalize__form--body input[type=text]").filter(function () {
    return $.trim($(this).val()).length == 0
  }).length == 0;
  // console.log(checkInput1);
  // if(checkInput1 === true){
  //   console.log("true");
  //   $("#pz-confirmed").prop("disabled", false);
  // }else{
  //   $("#addtocart").prop("disabled", true);
  // }
  $('.personalize-wrapper-options').after('<p class="p_note">NOTE : Once you approve your personalization and submit your order, you can no longer modify, cancel or return your personalized product. Please allow 8-10 business days for personalization, plus additional time for shipping.</p>');

  /* Sticky Filter on Mobile */
  if ( $(window).width() < 768) {  
    //console.log("run Code");
    $(window).scroll(function() {    
      var scroll = $(window).scrollTop();

      if (scroll >= 160) {
        $(".js-collection-buttons .section__foot-inner").addClass("darkHeader");
      } else {
        $(".js-collection-buttons .section__foot-inner").removeClass("darkHeader");
      }
    }); 
  }
      setTimeout(function(){
    
  $("div.personalize__form--header").find('span._price').first().text("+$0.00");
  $("#personalized_start").on("click", function(){
    $("div.personalize__form--header").find('span._price').first().text($("div.personalize__form--header").find('span._price').last().text());  
  });
  $("#no_personalization").on("click", function(){
    $("div.personalize__form--header").find('span._price').first().text("+$0.00"); 
  });
  }, 3000);
});


window.setInterval(function(){
  $(".gift-note__row input").keypress(function (e) {
    var mainValue = $(this).val();
    //console.log(isEmoji(mainValue));
    var key = e.keyCode || e.which;       
    $('.no-special').remove();
    //Regular Expression
    var reg_exp = /^[A-Za-z0-9_\-~!@#$%^&*()+=?/,. ]+$/;
    //Validate Text Field value against the Regex.
    var is_valid = reg_exp.test(String.fromCharCode(key));
    if (!is_valid) {
      $('.gift-note__notice').after('<p class="no-special">We unfortunately cannot print emojis or symbols in gift notes.</p>');
    }
    console.log(is_valid);
    return is_valid;
  });
  
  function isEmoji(str) {
    var ranges = [
      '(?:[\u2700-\u27bf]|(?:\ud83c[\udde6-\uddff]){2}|[\ud800-\udbff][\udc00-\udfff]|[\u0023-\u0039]\ufe0f?\u20e3|\u3299|\u3297|\u303d|\u3030|\u24c2|\ud83c[\udd70-\udd71]|\ud83c[\udd7e-\udd7f]|\ud83c\udd8e|\ud83c[\udd91-\udd9a]|\ud83c[\udde6-\uddff]|[\ud83c[\ude01-\ude02]|\ud83c\ude1a|\ud83c\ude2f|[\ud83c[\ude32-\ude3a]|[\ud83c[\ude50-\ude51]|\u203c|\u2049|[\u25aa-\u25ab]|\u25b6|\u25c0|[\u25fb-\u25fe]|\u00a9|\u00ae|\u2122|\u2139|\ud83c\udc04|[\u2600-\u26FF]|\u2b05|\u2b06|\u2b07|\u2b1b|\u2b1c|\u2b50|\u2b55|\u231a|\u231b|\u2328|\u23cf|[\u23e9-\u23f3]|[\u23f8-\u23fa]|\ud83c\udccf|\u2934|\u2935|[\u2190-\u21ff])' // U+1F680 to U+1F6FF
    ];
    if (str.match(ranges.join('|'))) {
      return true;
    } else {
      return false;
    }
  }
  
  /* On Hover Image PDP */
 /* $('.slick-slide').hover(function(){ 
    //console.log('Hi');
    $(this).trigger('click');
    $('.slick-slide').removeClass('slick-current');
    $(this).addClass('slick-current');
    var imgSrc = $(this).find('img').attr('src');
    var newImgsrc = imgSrc.replace("122x", "1270x");
    console.log(newImgsrc);
    $('.zoomContainer .zoomWindowContainer > div').css('background-image', 'url(' + newImgsrc + ')');
    $('.zoomContainer').css('background-image', 'url(' + newImgsrc + ')');
  });*/
  
  $('.cf-field input').on("focus", function() {
    $(this).parent().addClass('alt');
  }).on("blur", function() {
    if($(this).val() == ''){
       $(this).parent().removeClass('alt');
    }
    console.log($(this).val());
    
  });

  $(".cf-select-wrap select").children().first().text('');
  $("#169587").children().first().text('');
  
  $("#169587").change(function () {
        $(this).parent().parent().addClass('alt');
    });
  $("#694724").change(function () {
        $(this).parent().parent().addClass('alt');
    });
  
  
  if (!$("[data-cf-field-id='694724']").hasClass("alt")) {
    $("[data-cf-field-id='694724']").addClass('alt');
  }
},1000);

document.addEventListener( "DOMContentLoaded", load , false);

function load() {
  window.hlsVideo = hlsVideo( true , false );
}

function hlsVideo(init, showConsole = false) {
    let hlsObject = {
        mobileBreakpoint: 768,
        elements: [],
        mobileMedia: window.matchMedia("(max-width: 768px)"),
        init: function () {
            let videoElements = document.querySelectorAll('.hls-media');
            let parent = this;

            videoElements.forEach(function (video) {
                if (!video.initialized) {
                    let desktopSource = video.getAttribute('data-desktop-src');
                    let mobileSource = video.getAttribute('data-mobile-src');
                    let desktopPoster = video.getAttribute('data-desktop-poster');
                    let mobilePoster = video.getAttribute('data-mobile-poster');
                    let controlPlayer = video.getAttribute('data-controls');
                    let finalPoster = '';
                    let finalSource = '';
                    let windowWidth = window.outerWidth;

                    // Set poster
                    if (hlsObject.mobileMedia.matches) {
                        // Use mobile
                        if (mobilePoster && mobilePoster.length > 0) {
                            finalPoster = mobilePoster;
                        } else if (desktopPoster && desktopPoster.length > 0) {
                            finalPoster = desktopPoster;
                        } else {
                            console.warn('No desktop or mobile poster was specified for video element:', video);
                        }
                    } else {
                    
                        // desktop
                        if (desktopPoster && desktopPoster.length > 0) {
                            finalPoster = desktopPoster;
                        } else if (mobilePoster && mobilePoster.length > 0) {
                            finalPoster = mobilePoster;
                        } else {
                            console.warn('No desktop or mobile poster was specified for video element:', video);
                        }
                    }

                    if (finalPoster.length > 0) {
                        parent._setPoster(video, finalPoster);
                    }
                

                    if (showConsole) {
                        console.log('Initialized HLS playback on element', video);
                    }
                }
            });

            parent.sourceRebuild(this.mobileMedia);

        },
        _setSource: function (element, src) {
          // if the video is from shopify
          if ( src.includes('shopify') ) {
            element.src = src;
            element.addEventListener('loadedmetadata', function() {
              if (element.dataset.controls == false) {
                  element.play();
              }
            });

            return;
          } else if ( src.includes('youtube') ) {
            // stuff we need to do...
            element.classList.add('hidden');
            
            let closestParent = element.closest('.shopify-section');
            if ( closestParent ) {
              let idOfParent = closestParent.id;
              const injectionPointSelector = `#${idOfParent} .iframe-media`;
              let iframe = document.querySelector( injectionPointSelector );

              if ( iframe ) {
                let finalSrc = src;
                if ( element.dataset.controls == 'false' ) {
                  finalSrc += '&autoplay=1&playsinline=1&mute=1';
                } else {
                  finalSrc += '&autoplay=1&playsinline=1';
                }
                
                iframe.src = finalSrc;
              }
            }

            return;
          }


          if (Hls.isSupported()) {
              let hls = new Hls();
              hls.loadLevel = 4;

              element.pause();
              if ( showConsole ) {
                  console.log(element.dataset.controls);
              }

              hls.attachMedia(element);
              hls.on(Hls.Events.MEDIA_ATTACHED, function () {
              hls.loadSource(src);
              hls.on(Hls.Events.MANIFEST_PARSED, function (event, data) {
                  if (element.dataset.controls == false) {
                      element.play();
                  }
                  
                  hls.startLevel = (hls.levels.length - 1);
              });
              });

          } else if (element.canPlayType('application/vnd.apple.mpegurl')) {
            element.src = src;
            element.addEventListener('loadedmetadata', function() {
              if (element.dataset.controls == false) {
                  element.play();
              }
            });
          } else {
              console.error('The browser does not support HLS or application/vnd.apple.mpegurl');
          }
        },
        _setPoster: function (element, poster) {
            element.setAttribute('poster', poster);
        },
        sourceRebuild: function(x) {
        // Build out HLS elements as needed
        // x = matched media | true = Mobile | false = Desktop
        let videoElements = document.querySelectorAll('.hls-media');
        videoElements.forEach(function (video) {
            try {
                let desktopSource = video.getAttribute('data-desktop-src');
                let mobileSource = video.getAttribute('data-mobile-src');
                let finalSource = '';

                if (x.matches) {

                    if (mobileSource && mobileSource.length > 0) {
                        finalSource = mobileSource;
                    } else if (desktopSource && desktopSource.length > 0) {
                        finalSource = desktopSource;
                    } else {
                        throw 'No desktop or mobile video source was specified for video element.'
                    }
                    
                } else {

                    if (desktopSource && desktopSource.length > 0) {
                        finalSource = desktopSource;
                    } else if (mobileSource && mobileSource.length > 0) {
                        finalSource = mobileSource;
                    } else {
                        throw 'No desktop or mobile video source was specified for video element.'
                    }

                }

                hlsObject._setSource(video, finalSource);


                video.initialized = true;


            } catch (videoError) {
                console.log("Video Unable to Load" + videoError);
            }                
        });
    },
    playVideo: function() {
        document.querySelectorAll('.hls-media').forEach(function (video) {
            video.play();
        });
    }
}

    hlsObject.init();
    document.addEventListener('shopify:section:load', function () {
        hlsObject.init();
    });

    // Use Event Listener for Edge/Chrome/Firefox - Fallback to Listener for Safari v14 and below
    try {
        hlsObject.mobileMedia.addEventListener("change", (e)=> {
            hlsObject.sourceRebuild(e);
        });
    } catch(eSafari) {
        try {
            hlsObject.mobileMedia.addListener(hlsObject.sourceRebuild(e));
        } catch (safariIsBuggy) {
            if (showConsole) { 
                console.log("Matched Media Error");
            }
        }
    }

    // Logic to build out autoplay for mobile only
    const hlsVideoContainers = document.querySelectorAll('.video-panel-section');
    const mobilePlayPauseButtons = {
        instances: []
    }

    let instances = [];
    let instance = {
        hls_source_element: null,   // reference to this instances .hls-media
        buttons_wrapper: null,      // reference to this instances [data-mobile-buttons]
        play_button: null,          // reference to the play button .play-button
        pause_button: null,         // reference to the pause button .pause-button
    }

    for ( let i = 0; i < hlsVideoContainers.length; i++ ) {
        instance.hls_source_element = hlsVideoContainers[i].querySelector('.hls-media');
        instance.buttons_wrapper = hlsVideoContainers[i].querySelector('[data-mobile-buttons]');
        instance.play_button =  hlsVideoContainers[i].querySelector('.play-button');
        instance.pause_button = hlsVideoContainers[i].querySelector('.pause-button');

        instances.push( instance );
        instance = {};
    }

    mobilePlayPauseButtons.instances = instances;

    if ( showConsole ) {
        console.log( mobilePlayPauseButtons );
    }

    // loop through each button instance. 
    // If the instance does not have the wrapper, autoplay it.
    for ( let instance of mobilePlayPauseButtons.instances ) {
        if ( instance.buttons_wrapper === null ) {
            instance.hls_source_element.play();
        }
        else {
            //check if the element is currently hidden
            if ( window.getComputedStyle( instance.buttons_wrapper ).display === "none" ) {
                instance.hls_source_element.play();
            } else {
                // if on desktop view, play the element like normal
                // if on mobile view, show play icon, hide pause icon
                instance.play_button.classList.remove('hidden');
                instance.pause_button.classList.add('hidden');

                // Attatch listners to play button
                instance.play_button.addEventListener('click' , ( e ) => {
                    instance.hls_source_element.play();
                    instance.play_button.classList.add('hidden');
                    instance.pause_button.classList.remove('hidden');
                    instance.buttons_wrapper.classList.remove('focus');
                });

                // Attach listenrs to pause button
                instance.pause_button.addEventListener('click' , ( e ) => {
                    instance.hls_source_element.pause();
                    instance.play_button.classList.remove('hidden');
                    instance.pause_button.classList.add('hidden');
                    instance.buttons_wrapper.classList.add('focus');
                });
            }
        }
    }

    function onPlayerReady( event ) {
      event.target.playVideo();
    }
    
    return hlsObject;
}

/* Adding Delay in mega menu */

let isTabbing = false;

window.addEventListener('keydown', (e) => {
  if (e.key === 'Tab') {
    isTabbing = true;
  }
});

window.addEventListener('mousedown', () => {
  isTabbing = false;
});

const navDropdowns = document.querySelectorAll('.container-main-nav .links-list .nav__has-dropdown');

navDropdowns.forEach((menu) => {
  let enterTimeout, leaveTimeout;
  const dropdownButton = menu.querySelector('.link-dropdown-button');

  const showMenu = (source = 'hover') => {
    clearTimeout(leaveTimeout);
    enterTimeout = setTimeout(() => {
      menu.classList.remove('fading-out');
      menu.classList.add('open');
      dropdownButton?.setAttribute('aria-expanded', 'true');

      // Add class only if opened via keyboard
      if (source === 'keyboard') {
        menu.classList.add('keyboard-open');
      } else {
        menu.classList.remove('keyboard-open');
      }
    }, 200);
  };

  const hideMenu = () => {
    clearTimeout(enterTimeout);

    leaveTimeout = setTimeout(() => {
      if (menu.classList.contains('open')) {
        menu.classList.remove('open');
        menu.classList.add('fading-out');
        menu.classList.remove('keyboard-open');
        dropdownButton?.setAttribute('aria-expanded', 'false');

        setTimeout(() => {
          menu.classList.remove('fading-out');
        }, 400); // Match with CSS animation duration
      }
    }, 100);
  };

  // Hover behavior (desktop)
  menu.addEventListener('mouseenter', () => showMenu('hover'));
  menu.addEventListener('mouseleave', hideMenu);

  // Keyboard + screen reader behavior
  if (dropdownButton) {
    dropdownButton.setAttribute('aria-haspopup', 'true');
    dropdownButton.setAttribute('aria-expanded', 'false');

    // Only respond to real keyboard Tab focus
    dropdownButton.addEventListener('focus', () => {
      if (!isTabbing) return;
    });

    // Keyboard key handling (Enter, Space, Escape)
    dropdownButton.addEventListener('keydown', (e) => {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault(); // Prevent scroll on space

        const isOpen = menu.classList.contains('open');
        if (isOpen) {
          hideMenu();
        } else {
          showMenu('keyboard');
        }
      }

      if (e.key === 'Escape') {
        hideMenu();
        dropdownButton.focus();
      }
    });

    // Screen reader click handling
    dropdownButton.addEventListener('click', (e) => {
      const isOpen = menu.classList.contains('open');
      if (isOpen) {
        hideMenu();
      } else {
        showMenu('keyboard');
      }
    });

    // Hide menu when focus leaves entire menu
    const focusableEls = menu.querySelectorAll('a, button');
    focusableEls.forEach(el => {
      el.addEventListener('blur', () => {
        setTimeout(() => {
          if (!menu.contains(document.activeElement)) {
            hideMenu();
          }
        }, 10);
      });
    });
  }
});

/* Adding Delay in mega menu */

/*******************Wait Element Function****************/
  function waitForElement(selector, callback) {
    if (document.querySelector(selector) !== null) {
      callback();
    } else {
      setTimeout(function() {
        waitForElement(selector, callback);
      }, 100);
    }
  };

/*******************Wait Element Function****************/
waitForElement('.btn-chat a',function() {
  const chatBtn = document.querySelector('.btn-chat a');
  if(chatBtn != null){
    chatBtn.setAttribute('role', 'button');
    chatBtn.setAttribute('aria-label', 'Chat');
  }
});

// Trap Focus modal function
function trapFocus(modal) {
  const focusableSelectors = `
    a[href],
    area[href],
    input:not([disabled]):not([type="hidden"]),
    select:not([disabled]),
    textarea:not([disabled]),
    button:not([disabled]),
    [tabindex]:not([tabindex="-1"])
  `;

  const focusableElements = modal.querySelectorAll(focusableSelectors);
  const first = focusableElements[0];
  const last = focusableElements[focusableElements.length - 1];

  function handleKeydown(e) {
    if (e.key !== 'Tab') return;

    if (e.shiftKey) {
      if (document.activeElement === first) {
        e.preventDefault();
        last.focus();
      }
    } else {
      if (document.activeElement === last) {
        e.preventDefault();
        first.focus();
      }
    }
  }

  modal.addEventListener('keydown', handleKeydown);

  modal.addEventListener('modalClose', () => {
    modal.removeEventListener('keydown', handleKeydown);
  });
}

/* Cart modal ADA */
let lastFocusedCartTrigger = null;

$(document).on('click', '.js-product-btn, .js-btn-cart', function () {
  lastFocusedCartTrigger = this;
});

function closeCartModal() {
  const $widgetCart = $('.js-widget-cart');

  $widgetCart.removeClass('expanded');
  $widgetCart[0].dispatchEvent(new CustomEvent('modalClose'));

  if (lastFocusedCartTrigger) {
    setTimeout(() => {
      $(lastFocusedCartTrigger).attr('tabindex', '0').focus();
    }, 100);
  }
  lastFocusedQtyMeta = null;
  shouldRestoreQtyFocus = false;
}
// Close modal on press enter key
$(document).on('click keydown', '.cart-close-button', function (e) {
  if (e.type === 'click' || e.key === 'Enter' || e.keyCode === 13 ) {
    e.preventDefault();
    closeCartModal();
  }
});
// Close modal on Escape key
$(document).on('keydown', function (e) {
  if (e.key === 'Escape' || e.keyCode === 27) {
    const $widgetCart = $('.js-widget-cart');
    if ($widgetCart.hasClass('expanded')) {
      e.preventDefault();
      closeCartModal();
    }
  }
});
/* Cart modal ADA */

/* Search modal ADA */
$(document).on('keydown', function(e) {
  // Open search bar when `/` is pressed
  if (e.key === '/' && !$('input, textarea').is(':focus')) {
    e.preventDefault();
    $('.header').addClass('header--search');
    $('.js-search').focus();
  }
});

// Perform Actions on Close button
$(document).on('keydown', '.btn-close-primary', function(e) {
  const hasSearchResults = getSearchResultLinks().length > 0;

  // Shift + Tab: Go to last search result if present
  if (e.key === 'Tab' && e.shiftKey) {
    if (hasSearchResults) {
      e.preventDefault();
      setTimeout(() => {
        ensureAriaLabelExists();
        applyAriaToResultsContainer();

        const results = getSearchResultLinks();
        results[results.length - 1].focus();
      }, 100);
    }
  }

  // Tab (forward): Go to first search result if present
  if (e.key === 'Tab' && !e.shiftKey) {
    if (hasSearchResults) {
      e.preventDefault();
      setTimeout(() => {
        ensureAriaLabelExists();
        applyAriaToResultsContainer();
        focusFirstResult();
      }, 100);
    } else {
      // No results — return focus to input
      setTimeout(() => {
        $('.js-search input').trigger('focus');
      }, 100);
    }
  }
});

// Move focus to Search bar after closing the popup
$(document).on('click keydown', '.search-close-button', function(e) {
  if ((e.type === 'keydown' && e.key === 'Enter') || (e.type === 'click')) {
    setTimeout(() => {
      $('.js-btn-search-desktop').attr('tabindex', '0').trigger('focus');
    }, 500);
  }
});

// Move focus to Close button on back navigation
$(document).on('keydown', '#bc-sf-search-box-1', function(e) {
  if (e.key === 'Tab' && e.shiftKey) {
    setTimeout(() => {
      $('.btn-close-primary').trigger('focus');
    }, 100);
  }
});

let tabToSearchResults = false;

// Inject screen-reader-only label if missing
function ensureAriaLabelExists() {
  if ($('#aria-search-label').length === 0) {
    $('<div>', {
      id: 'aria-search-label',
      text: 'Search results below',
      class: 'sr-only',
      'aria-hidden': 'false'
    }).appendTo('body');
  }
}

// Apply ARIA roles and attributes to results container
function applyAriaToResultsContainer() {
  const $resultsContainer = $('.bc-sf-search-suggestion').first();
  if ($resultsContainer.length) {
    $resultsContainer.attr({
      'role': 'listbox',
      'aria-labelledby': 'aria-search-label',
      'tabindex': '-1'
    });
  }
}

// Get all visible and focusable search result links
function getSearchResultLinks() {
  return $('.bc-sf-search-suggestion-group-wrapper-right a:visible').toArray();
}

// Focus first search result link
function focusFirstResult() {
  const results = getSearchResultLinks();
  if (results.length > 0) {
    results[0].focus();
  }
}

// Detect Tab key after typing in the search input
$(document).on('keydown', '[data-class="header--search"]', function(e) {
  if (e.key === 'Tab' && !e.shiftKey) {
    tabToSearchResults = true;
  }
});

// After Tab keypress, shift focus to first result
$(document).on('keyup', '[data-class="header--search"]', function(e) {
  if (e.key === 'Tab' && tabToSearchResults) {
    ensureAriaLabelExists();
    applyAriaToResultsContainer();

    const $noResultSpan = $('.bc-sf-search-suggestion-no-result span');
    if ($noResultSpan.length) {
      $noResultSpan.attr('tabindex', '0');
      $noResultSpan.focus();

      // Allow screen reader to read it, then return focus to input
      setTimeout(() => {
        $('#bc-sf-search-box-1').focus();
      }, 1000); // 100–300ms usually works well
    } else {
      focusFirstResult();
    }

    tabToSearchResults = false;
  }
});

// Handle Tab and Shift+Tab inside the search result dropdown
$(document).on('keydown', '.bc-sf-search-suggestion-group-wrapper-right a:visible', function(e) {
  if (e.key === 'Tab') {
    // Reference to the search input element
    const $searchInput = $('#bc-sf-search-box-1');
    $searchInput.attr('tabindex', 0);

    const results = getSearchResultLinks();
    const currentIndex = results.indexOf(this);
    if (e.shiftKey) {
      // Shift + Tab: Cycle back to input if at first item
      if (currentIndex === 0) {
        e.preventDefault();
        $searchInput.focus();
      }
    } else {
      // Tab: Cycle back to input if at last item
      if (currentIndex === results.length - 1) {
        e.preventDefault();
        $searchInput.focus();
      }
    }
  }
});

/* Search modal ADA */
/***** Mobile menu dropdown ****/
$('.header__mobile .nav .link-dropdown-button').on('click', function (e) {
  var $this = $(this);
  var $parent = $(this).closest('.nav__has-dropdown');
  var $dropdown = $parent.find('.nav__dropdown');
  
  if ($parent.hasClass('expanded')) {
    $dropdown.slideUp();
    $parent.removeClass('expanded'); 
    $this.attr('aria-expanded', 'false');
  } else {
    $dropdown.slideDown(); 
    $parent.addClass('expanded');
    $this.attr('aria-expanded', 'true');
    
    // Close dropdowns
    $parent.siblings().removeClass('expanded').find('.nav__dropdown').slideUp();
    $parent.siblings().find('.link-dropdown-button').attr('aria-expanded', 'false');
  }
});


// Move focus to share icon when enter
$(document).on('click keydown', '.share-outer', function (e) {
  if (e.type == 'click' || e.key === 'Enter' || e.keyCode === 13) {
    const $firstLink = $(this).find('.share ul li:first-child a');

    if ($firstLink.length) {
      setTimeout(() => {
        $firstLink.focus();
      }, 200);
    }
  }
});

// Move focus to first card after switch pagination
$(document).on('click keydown', '#bc-sf-filter-bottom-pagination li a', function (e) {
  if (e.type == 'click' || e.key === 'Enter' || e.keyCode === 13) {
    setTimeout(() => {
      const product_list_item = $('#bc-sf-filter-products .js-product-item:first-child .product-item__images figure:first-child a');
      
      setTimeout(() => {
        product_list_item.attr('tabindex', '0');
        product_list_item.focus();
      },100);
      console.log(product_list_item);
    }, 1000);
  }
});

// Updating Attributes of filter button on screen readers
$(document).on('click keydown', '#bc-sf-filter-options-wrapper .filter-button', function (e) {
  if (e.type === 'click' || e.key === 'Enter' || e.keyCode === 13) {
    setTimeout(() => {
      const $filterBlock = $(this).closest('.bc-sf-filter-option-block');
      const isExpanded = $filterBlock.hasClass('expanded');
      const $filterButton = $filterBlock.find('.filter-button');
      
      $filterButton.attr('aria-expanded', isExpanded ? 'true' : 'false');
    }, 200);
  }
});

// Close filter panels on outside click or focus
$(document).on('click focusin', function (e) {
  const $wrapper = $('#bc-sf-filter-options-wrapper');
  const $activeBlock = $wrapper.find('.bc-sf-filter-option-block.expanded');

  if ($activeBlock.length && !$activeBlock.is(e.target) && $activeBlock.has(e.target).length === 0) {
    $activeBlock.removeClass('expanded');
    $activeBlock.find('.filter-button').attr('aria-expanded', 'false');
  }
});

// Updating Attributes of Sort button on screen readers
$(document).on('click keydown', '.bc-sf-filter-custom-sorting .label', function (e) {
  if (e.type === 'click' || e.key === 'Enter' || e.keyCode === 13) {
    setTimeout(() => {
      const $filterBlock = $(this).closest('.bc-sf-filter-custom-sorting');
      const isExpanded = $filterBlock.hasClass('bc-sf-filter-sort-active');
      const $filterButton = $filterBlock.find('.label');
      
      $filterButton.attr('aria-expanded', isExpanded ? 'true' : 'false');
    }, 200);
  }
});

// Close dropdown on outside click or focus
$(document).on('click focusin', function (e) {
  const $dropdown = $('.bc-sf-filter-custom-sorting');
  
  if (!$dropdown.is(e.target) && $dropdown.has(e.target).length === 0) {
    $dropdown.removeClass('bc-sf-filter-sort-active');
    $dropdown.find('.bc-sf-filter-filter-dropdown').hide();
    $dropdown.find('.label').attr('aria-expanded', 'false');
  }
});

// Close selectric modal when click outside the modal
$(document).on('click', function (event) {
  if (!$(event.target).closest('.selectric-wrapper').length && $('.selectric-open').length) {
    $('select').selectric('close');
  }
});

// Trigger search input click on input event
const searchInput = document.querySelector('.bc-sf-search-suggestion-mobile-top-panel .bc-sf-search-box');

if (searchInput) {
  searchInput.addEventListener('input', () => {
    setTimeout(() => {
    searchInput.click();
    }, 500);
  });
}